import { render, staticRenderFns } from "./verAddModel.vue?vue&type=template&id=84f42d50&scoped=true&"
import script from "./verAddModel.vue?vue&type=script&lang=js&"
export * from "./verAddModel.vue?vue&type=script&lang=js&"
import style0 from "./verAddModel.vue?vue&type=style&index=0&id=84f42d50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f42d50",
  null
  
)

export default component.exports